import { CreditCard, MessageSquare, Globe } from 'lucide-react';
import { PageHeader } from '@/components/PageHeader';
import { Card, CardContent } from '@/components/ui/card';


const integrations = [
  {
    icon: CreditCard,
    title: 'Payment',
    description: 'Connect payment gateways like Razorpay, Stripe, or PayU to accept digital payments directly from POS and quotations.',
  },
  {
    icon: MessageSquare,
    title: 'Messaging',
    description: 'Send order confirmations, quotations, and low-stock alerts via WhatsApp, SMS, or email to customers and staff.',
  },
  {
    icon: Globe,
    title: 'Website Update CMS',
    description: 'Sync your inventory and pricing directly to your website. Keep your online catalogue up to date automatically.',
  },
];

export function IntegrationsPage() {
  return (
    <div>
      <PageHeader
        title="Integrations & Plugins"
        subtitle="Connect CHHABIGHAR with your favourite tools and services."
      />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {integrations.map((item) => {
          const Icon = item.icon;
          return (
            <Card key={item.title} className="flex flex-col p-5 min-h-[140px]">
              <CardContent className="p-0 flex flex-col flex-1">
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gold-500/15 text-gold-600">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-3 font-semibold text-sm">{item.title}</h3>
                <p className="mt-1 text-xs text-muted-foreground leading-relaxed">
                  {item.description}
                </p>
              </CardContent>
            </Card>
          );
        })}
      </div>
      

      <div className="mt-6 rounded-lg border border-gold-200 bg-gold-50/50 p-4 text-sm text-muted-foreground">
        <span className="font-medium text-foreground">Want an integration?</span> Contact support at{' '}
        <a
          href="https://support.nicecare.co/chat"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-gold-600 underline underline-offset-2 hover:text-gold-700"
        >
          support.nicecare.co/chat
        </a>{' '}
        and raise a request. Our team will prioritise based on demand.
      </div>
    </div>
  );
}
